import "../index.css";
import { PencilIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ImageGallery } from "@/components/ImageGallery";
import type { IInspectorW9Form } from "@/types/users-inspectors";
import { Card, Heading, IconButton, LabelValue, Row, Tooltip } from "@/ui-kit";

type IProps = {
  w9Form: IInspectorW9Form;
  onEdit?: () => void;
};

export const TaxInformationDetailsCard = ({ w9Form, onEdit }: IProps) => {
  const { t } = useTranslation();
  const labelWidth = "128px";

  return (
    <Card className="profile-card">
      <Card.Body>
        <Row gap="xl" alignmentVertical="top">
          <div className="profile-card__image-gallery">
            <ImageGallery imageUrls={[w9Form.frontImageUrl]} />
          </div>
          <div className="profile-card__details">
            <Row gap="sm">
              <Heading level={3} tone="default">
                {t("label.tax_information")}
              </Heading>

              {onEdit && (
                <div className="profile-card__actions">
                  <Tooltip content={t("action.edit")} placement="bottom-end">
                    <IconButton
                      size="sm"
                      variant="ghost"
                      color="neutral"
                      content={<PencilIcon />}
                      onClick={onEdit}
                      aria-label={t("action.edit")}
                    />
                  </Tooltip>
                </div>
              )}
            </Row>

            <div className="profile-card__sections">
              <div className="profile-card__section">
                <LabelValue
                  label={t("label.business_name")}
                  value={w9Form.name}
                  labelWidth={labelWidth}
                  canCopy
                />
                <LabelValue
                  label={t("label.tin")}
                  value={w9Form.tin}
                  labelWidth={labelWidth}
                  canCopy
                />
                <LabelValue
                  label={t("label.ssn_ein")}
                  value={w9Form.ssn}
                  labelWidth={labelWidth}
                  canCopy
                />
                <LabelValue
                  label={t("label.entity_type")}
                  value={w9Form.entityType}
                  labelWidth={labelWidth}
                />
              </div>
            </div>
          </div>
        </Row>
      </Card.Body>
    </Card>
  );
};
